<template>
  <div>

    <div class="instructor-form- text-center mt-5">
      <h4>Terima kasih telah melakukan Registrasi</h4>
    </div>

  </div>
</template>



<script>
  export default {
    props: ["dataprop"],
    data() {
      return {
        eventname: process.env.MIX_APP_NAME,
        url: "",
      };
    },
    created() {

    },
    methods: {
      initial() {

      },
      getBankLogo(){
        return '/bank/mandiri.png'
      },
      getBiaya(){
      // return (this.dataprop.profesi==="dokter spesialis")?"Rp 200.000":"Rp 100.000"
      return `${this.dataprop.payment}(${this.dataprop.profesi} & ${this.dataprop.plan} )`
    }

    
  },
  mounted: function(){
    var target = document.querySelector("#registercourse");
            $('html, body').animate({
              scrollTop: $(target).offset().top
            }, 500);
          }
        };
      </script>
      <style src='vue-multiselect/dist/vue-multiselect.min.css'></style>
      <style>
        .multiselect__input{
          width:0px!important; 
        }


      </style>
